import { useState, useCallback, useEffect } from "react";
import { payrollSummaryStagingService } from "../services/payrollSummaryStagingService";
import { SetAuditTrail } from "../../components/Reports/AuditTrailReportEmployeeSetup";

export const useProcessPayroll = ({ showGeneralMessage, apiFilterPayload, user }) => {
	const [loading, setLoading] = useState(false);
	const [payrollData, setPayrollData] = useState([]);
	const [filterData, setFilterData] = useState([]);

	// -- Fetches --
	const fetchDataProcessedPayroll = useCallback(async () => {

		const { PayrollPeriodId, PayTypeId, ClassificationId } = apiFilterPayload;

		// GUARD: Don't fetch if any of the three are missing or 0
		if (!PayrollPeriodId || !PayTypeId || !ClassificationId) return;

		setLoading(true);

		try {
			const res = await payrollSummaryStagingService.getProcessedPayroll(apiFilterPayload);
			setPayrollData(res.data || []);
			setFilterData(res.data || []);
		} catch (err) {
			console.error("Error: ", err)
			showGeneralMessage("Failed to load Processed Payroll", false);
		} finally {
			setLoading(false);
		}
	}, [apiFilterPayload, showGeneralMessage]);

	useEffect(() => {
		fetchDataProcessedPayroll();
	}, [fetchDataProcessedPayroll]);


	// -- Actions --
	const processPayroll = async (param) => {
		await payrollSummaryStagingService.processPayroll(param);

		await SetAuditTrail({
			setupArea: "Payroll",
			actionTaken: "process",
			field: "Process Payroll",
			newValue: `-`,
			oldValue: "-",
			dateSaved: new Date(),
			savedById: user.id,
		});
	};
	const revertPayroll = async (param) => {
		try {
			await payrollSummaryStagingService.revertPayroll(param);

			await SetAuditTrail({
				setupArea: "Payroll",
				actionTaken: "revert",
				field: "Revert Payroll",
				newValue: `-`,
				oldValue: "-",
				dateSaved: new Date(),
				savedById: user.id,
			});
		} catch (err) {
			throw err;
		}
	};

	const postPayroll = async (param) => {
		try {
			await payrollSummaryStagingService.postPayroll(param);

			await SetAuditTrail({
				setupArea: "Payroll",
				actionTaken: "post",
				field: "Post Payroll",
				newValue: `-`,
				oldValue: "-",
				dateSaved: new Date(),
				savedById: user.id,
			});
		} catch (err) {
			throw err;
		}
	};

	return {
		// Data and states
		loading,
		payrollData,
		setPayrollData,
		filterData,
		setFilterData,

		// Actions
		processPayroll,
		revertPayroll,
		postPayroll,

		// Fetches
		fetchDataProcessedPayroll
	};
};